/* shah */
import React from 'react'

const StopAnimationIcon = () => {
    return (
        <svg id="SmallBoxSVG-noStoping" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M2305 5113 c-671 -72 -1279 -393 -1707 -903 -301 -358 -488 -764
-571 -1240 -19 -109 -21 -162 -21 -410 0 -248 2 -301 21 -410 94 -540 320
-987 693 -1374 383 -398 866 -650 1430 -749 109 -19 162 -21 410 -21 313 0
407 10 653 73 882 228 1600 946 1828 1828 63 246 73 340 73 653 0 313 -10 407
-73 653 -228 881 -946 1600 -1828 1828 -227 58 -334 71 -613 74 -140 2 -273 1
-295 -2z m540 -662 c412 -66 773 -249 1065 -541 297 -297 483 -670 545 -1092
23 -157 17 -456 -13 -608 -50 -250 -140 -478 -267 -673 l-50 -77 -1332 1332
-1332 1332 82 54 c228 149 468 234 807 285 14 3 104 5 200 6 128 0 207 -4 295
-18z m732 -3509 c-190 -125 -417 -214 -667 -264 -152 -30 -450 -36 -608 -13
-422 62 -795 248 -1092 545 -297 297 -483 670 -545 1092 -23 157 -17 456 13
608 50 250 140 478 267 673 l50 77 1332 -1332 1332 -1332 -82 -54z"/>
            </g>
        </svg>

    )
}

export default StopAnimationIcon